import { FormArray } from '@angular/forms';
import { swapArrayLocs } from 'esuite-util';

export const swapFormArrayLocs = (fa: FormArray, index1: number, index2: number) => {
  const swapped = swapArrayLocs(fa.value, index1, index2);
  fa.setValue(swapped);
}
